<template>
  <div class="container">
    <div class="text-center error_content">
      <div>
        <div class="error">
          <span>404</span>
        </div>
        <div class="error-type">
          <span>Page not found.</span>
        </div>
      </div>
      <hr class="seperator" />
      <div class="button-row">
        <router-link to="/" class="btn btn-primary link-home" exact>Go Home</router-link>
        <span class="px-2"></span>
        <a href="/" class="btn btn-primary link-home" @click.prevent.stop="go_back">Go Back</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "err404",
  mounted: function() {},
  destroyed: function() {},
  methods: {
    go_back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/custom.scss";

.container {
  color: #fff;
  max-width: 768px;
  margin: auto;
}

.error_content {
  margin-top: 7%;
}

.button-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.error {
  font-size: 150px;
  line-height: 160px;
  color: #555;
}

.error-type {
  font-size: 28px;
  color: #999;
}

.error-msg {
  font-size: 18px;
  margin: 45px 0;
  color: #333;
}

.seperator {
  border: 0;
  height: 2px;
  margin: 20px 0;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0)
  );
}
</style>
